import { render, staticRenderFns } from "./ManualTypeDetailsContainer.vue?vue&type=template&id=53759a73"
import script from "./ManualTypeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./ManualTypeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports